<template>
  <div
    class="container"
    :class="customClass"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseContainer',
  props: {
    fluid: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    customClass() {
      let customClass = '';
      if (this.fluid === true) {
        customClass += 'base-container--fluid';
      }
      return customClass;
    },
  },
};
</script>

<style lang="scss" scoped>
  .container {
    padding: 0;
  }
.base-container--fluid{
    max-width: 100% !important;
}
</style>
